import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, CalendarHeart, ArrowRight } from "lucide-react";

// Gentle "Book a Call" invitation popup, brand-styled.
// Appears ~5s after landing on the Home page, on each visit. Dismissible.
export default function BookCallPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm animate-in fade-in"
        onClick={close}
      />

      {/* Card */}
      <div className="relative w-full max-w-3xl bg-white rounded-2xl shadow-2xl overflow-hidden grid md:grid-cols-2 animate-in fade-in zoom-in-95 duration-300">
        {/* Close */}
        <button
          onClick={close}
          aria-label="Close"
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 md:bg-white flex items-center justify-center text-neutral-500 hover:text-neutral-800 hover:rotate-90 transition-all shadow"
        >
          <X size={18} />
        </button>

        {/* Left: image */}
        <div className="hidden md:block relative">
          <img
            src="/brand/kamla-pink-forward.png"
            alt="Kamla Das"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--purple)]/40 to-transparent" />
        </div>

        {/* Right: content */}
        <div className="p-8 md:p-10 bg-gradient-to-br from-[#effaf9] to-white">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[var(--teal)] text-white mb-5">
            <CalendarHeart size={22} />
          </span>
          <h2 className="font-serif-brand text-3xl md:text-4xl text-purple leading-tight">
            Ready to feel your best?
          </h2>
          <p className="text-neutral-600 leading-relaxed mt-3">
            Book a <span className="font-semibold text-[var(--teal-dark)]">free 30-minute
            consultation</span> with Coach Kam and take the first gentle step toward a healthier
            mind, body, and soul.
          </p>

          <Link to="/book" onClick={close} className="btn-brand btn-teal w-full mt-6">
            Book a Call <ArrowRight size={16} />
          </Link>

          <button
            onClick={close}
            className="block w-full text-center text-xs tracking-wide-sm uppercase text-neutral-400 mt-4 hover:text-neutral-600 transition-colors"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
